import styled from 'styled-components';

import { BorderRadius, BorderWidth, FontSize, MediaQuery, Spacing } from '@ninox/ninox-components/theme';
import { level } from '@ninox/ninox-components/theme/utils';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: stretch;

    width: 22rem;
    gap: ${Spacing.large};
    margin: 0 auto;
    margin-bottom: 5%;
    padding: ${Spacing.xx_large} ${Spacing.large};

    color: ${({ theme }) => theme.text.primary};
    background-color: ${({ theme }) => theme.surface.primary};

    border-width: ${BorderWidth.tiny};
    border-style: solid;
    border-color: ${({ theme }) => theme.grid.primary};
    border-radius: ${BorderRadius.largest};

    filter: drop-shadow(${({ theme }) => level.d4(theme.grid.primary)});

    font-size: ${FontSize.x_large};
    text-wrap: balance;

    pointer-events: all;
    position: relative;

    @media ${MediaQuery.S} {
        padding: ${Spacing.xx_large};
        width: 25rem;
    }
`;
